export default __webpack_public_path__ + "static/media/sidebar-orange@2x.92aa0b29.png";